/**
 * @file コンポーネント：フル動画ページスレッドボタン ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ButtonThread = (props) => {
    /**
     * スレッドを開く処理
     */
    const fnOnClickThread = (e) => {
        // クリックデフォルト処理をキャンセル
        e.preventDefault();
        // スレッドを開く
        props.setIsOpenPopupThread(true);
    };

    // Presenterに渡す
    return <Presenter {...props} fnOnClickThread={fnOnClickThread} />;
};
